import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { LocalStorageService, SessionService } from 'brainloper-ui';
import { catchError, switchMap } from 'rxjs/operators';
import { AuthenticationService } from './authentication.service';
import { Observable, of, throwError } from 'rxjs';
import { BaseResponse } from 'app/models2/commos/base-response';
import { RefreshToken } from 'app/models2/administration/refresh-token';
@Injectable({
  providedIn: 'root',
})
export class AuthInterceptorService {
  constructor(
    private storage: LocalStorageService,
    private authenticationService: AuthenticationService,
    private session: SessionService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<Object>> {
    const token: string = this.storage.get('token');
    let request = req;
    request.headers.set('Access-Control-Allow-Origin', '*');

    if (token) {
      request = this.addTokenHeader(request, token);
    }

    if (this.storage.get('date')) {
      this.compareDates();
    }

    return next.handle(request).pipe(
      catchError((err) => {
        if (err.status === 401) {
          return this.handler401Error(request, next);
        }
        // this.authenticationService.Logout()
        return throwError(() => err);
      })
    );
  }

  private compareDates() {
    const loginDate: Date = new Date(this.session.getData('date'));
    const logoutDate: Date = new Date(this.storage.get('date'));

     if (loginDate < logoutDate) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = location.href;
      document.body.appendChild(form);
      form.submit();
      window.location.reload();

      if (this.storage.get<boolean>('initSession')) {
        this.session.setData('date', new Date());
      } 
    }
    
  }

  private handler401Error(request: HttpRequest<any>, next: HttpHandler) {
    const token: string = this.storage.get('token');
    const refreshToken: number = this.storage.get('refreshToken');
    if (token && refreshToken > Math.floor(Date.now() / 1000)) {
      return this.authenticationService.RefreshToken(token).pipe(
        switchMap((res: BaseResponse<RefreshToken>) => {
          if (res.code === 0) {
            this.storage.set<string>('token', res.body.token);
            this.storage.set<number>('refreshToken', res.body.refreshToken);
            return next.handle(this.addTokenHeader(request, res.body.token));
          }
        }),
        catchError((err) => {
          this.authenticationService.Logout();
          return of();
        })
      );
    } else {
      this.authenticationService.Logout();
      return of();
    }
  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {
    return request.clone({
      setHeaders: {
        authorization: `Bearer ${token}`,
      },
    });
  }
}
